import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { observer } from 'mobx-react-lite';
import { Pressable, useWindowDimensions, View } from 'react-native';
import { BottomSheetProjectMobile } from '../../bottom-sheet-project-mobile/BottomSheetProjectMobile';
import { useRef, useEffect, useCallback } from 'react';
import { useStore } from 'src/contexts/StoreContext';
import { HEADER } from '../../headers/header/header.constants';
import { bottomSheetMobileHeaderGap } from './BottomSheetMobile.constants';
import { styles } from './BottomSheetMobile.style.';

export const BottomSheetMobile = observer(() => {
  const {
    bottomSheet: {
      bottomSheetVisible,
      closeBottomSheet,
      isSecondLevelLookup,
      showOpacityBackground,
      showDragIndicator,
      contentViewStyle,
    },
  } = useStore();
  const bottomSheetModalRef = useRef<BottomSheetModal>(null);
  const { height } = useWindowDimensions();

  useEffect(() => {
    if (bottomSheetVisible) {
      bottomSheetModalRef.current?.present();
    } else {
      bottomSheetModalRef.current?.dismiss({ duration: 400 });
    }
  }, [bottomSheetVisible]);

  const handleSheetChanges = useCallback((index: number) => {
    if (index === -1) {
      closeBottomSheet();
    }
  }, []);

  return (
    <>
      {bottomSheetVisible && showOpacityBackground && (
        <View style={styles.overlay}>
          <Pressable style={{ flex: 1 }} onPress={closeBottomSheet} />
        </View>
      )}
      <BottomSheetModal
        ref={bottomSheetModalRef}
        onChange={handleSheetChanges}
        onDismiss={() => {
          closeBottomSheet();
        }}
        enableOverDrag={false}
        enableContentPanningGesture={true}
        maxDynamicContentSize={height - HEADER.height.mobile - bottomSheetMobileHeaderGap}
        handleIndicatorStyle={showDragIndicator ? styles.dragIndicator : styles.noDragIndicator}
        enableDynamicSizing
        style={styles.bottomSheet}
      >
        <BottomSheetProjectMobile
          bsStyle={{
            ...styles.bottomSheetContainer,
            ...(isSecondLevelLookup ? { minHeight: 300 } : {}),
            ...contentViewStyle,
          }}
        />
      </BottomSheetModal>
    </>
  );
});
